
export default{
        beach: {
            "Height": {
                title: "Height",
                units:"in",
                id: 1
            },
            "Reach": {
                title: "Reach",
                units:"in",
                id: 2
            },
            "Approach_Touch": {
                title: "Approach Touch",
                units:"in",
                id: 3
            },
            "Block_Touch": {
                title:"Block Touch",
                units:"in",
                id:4
            },
            "Vertical":{
                title: "Vertical",
                units:"in",
                id:5
            },
            "Attack_Height": {
                title: "Attack Height",
                units:"in",
                id: 19
            },
            // "Standing_Broad_Jump":{
            //     title: "Standing Broad Jump",
            //     units:"ft",
            //     id:6
            // },
            "Star":{
                title: "Star",
                units:"sec",
                id:7
            },
            "GPA":{
                title: "GPA",
                units:"float",
                id:20
            },
            // "Sprint":{
            //     title: "Sprint",
            //     units:"sec",
            //     id:8
            // },
            // "Serve_To_Block":{
            //     title: "Serve To Block",
            //     units:"sec",
            //     id:9
            // }
        },
        volleyball: {

            "Height": {
                title: "Height",
                units:"ft",
                id: 13
            },
            "Reach": {
                title: "Reach",
                units:"in",
                id: 14
            },
            "Approach_Touch": {
                title: "Approach Touch",
                units:"ft",
                id: 15
            },
            "Block_Touch": {
                title: "Block Touch",
                units:"in",
                id: 16
            },
            "Vertical": {
                title: "Vertical",
                units:"in",
                id: 17
            },
            "Attack_Height": {
                title: "Attack Height",
                units:"in",
                id: 18
            }
        }
   };
